import React from 'react'
export const mobile_menu_close = {
  path: (
    <>
      <rect
        x="0.5"
        y="0.5"
        width="49"
        height="49"
        rx="24.5"
        opacity="0.7"
        stroke="currentColor"
        fill="transparent"
        key="SFYpH0OZd"
      />
      <path
        d="M32.0717 19.3431C32.4623 18.9526 32.4623 18.3194 32.0717 17.9289C31.6812 17.5384 31.0481 17.5384 30.6575 17.9289L25.0007 23.5857L19.3438 17.9289C18.9533 17.5384 18.3201 17.5384 17.9296 17.9289C17.5391 18.3194 17.5391 18.9526 17.9296 19.3431L23.5865 24.9999L17.9296 30.6568C17.5391 31.0473 17.5391 31.6805 17.9296 32.071C18.3201 32.4615 18.9533 32.4615 19.3438 32.071L25.0007 26.4142L30.6575 32.071C31.0481 32.4615 31.6812 32.4615 32.0717 32.071C32.4623 31.6805 32.4623 31.0473 32.0717 30.6568L26.4149 24.9999L32.0717 19.3431Z"
        fill="currentColor"
        key="3zsKkcdVLk"
      />
    </>
  ),
  viewBox: '0 0 50 50',
}
